import React from 'react';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import { ProjectLink, ProjectsLink } from '../../../links/index.jsx';

const ChangeInsightsCustomizeDashboardHeader = ({ project, page }) => {
  return project ? (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
        <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        <span>{page}</span>
      </BreadCrumbs>
    </PageHeader>
  ) : null;
};

export default ChangeInsightsCustomizeDashboardHeader;
